enum EIntervalName {
  INITIAL = 'initial',
  COMPARISON = 'comparison',
}

export default EIntervalName;
